import clearValue from './chains/clearValue'
import filterOptions from './chains/filterOptions'
import focusField from './chains/focusField'
import selectAllOptions from './chains/selectAllOptions'
import selectOption from './chains/selectOption'
import { init, translate } from '@billes/translator-client'

export default () => {
  return module => {
    module.addServices({
      translate: {
        init,
        t: translate
      }
    })

    module.addSignals({
      filterOptions,
      selectOption,
      clearValue,
      selectAllOptions,
      focusField
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/client/index.js